export default __webpack_public_path__ + "static/media/factory__44.0a94450e.jpg";